import React, { useCallback } from 'react';
import Select from "react-select";
import triangle from "../../images/triangle.svg";
import { addTrailingZeros, formatPrice } from '../helpers/common';

const RowComponent = ({ orderDetailItem, allAgents, units, handleCountChange, handleBuyPriceChange, agentSelectedValue, unitSelectedValue, handleInputChange }) => {

    const CustomOptionAgent = useCallback((props) => {
        return (
            <div>
                <div
                    className=""
                    style={{
                        background: props.isFocused
                            ? '#01B1E3'
                            : props.isSelected
                                ? 'rgb(54, 179, 126)'
                                : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
                    }}
                    {...props.innerProps}
                    ref={props.innerRef}
                >
                    {props.label}
                </div>
            </div>
        )
    }, [])

    let ProductName = `${orderDetailItem.ProductName} ${orderDetailItem.ClassName || ''} ${orderDetailItem.SizeName || ''} `;
    ProductName = ProductName?.replace(/\s+/g, ' ').trim();
    
    return (
        <tr key={orderDetailItem.ODID} className="custom-space">
            <td valign="middle">
                <img src={triangle} className="indicator" alt="" />
            </td>
            <td>
                <Select className="input-sm input-width-160"
                    options={allAgents}
                    value={agentSelectedValue}
                    placeholder="Select Agent"
                    onChange={(e) => { handleInputChange(e.value, 'AgentID', orderDetailItem.ODID) }}
                    components={{ Option: CustomOptionAgent }}
                ></Select>
            </td>
            <td className="cps-15">
                <input
                    type="text"
                    value={orderDetailItem.CustomerCode}
                    className="form-control input-sm input-width-110"
                    disabled
                />
            </td>
            <td className="fw-medium">
                <input
                    type="text"
                    value={orderDetailItem.Qty}
                    className="form-control input-sm input-width-80"
                    onChange={(e) => { handleInputChange(formatPrice(e.target.value), 'Qty', orderDetailItem.ODID) }}
                    onBlur={(e) => { handleInputChange(addTrailingZeros(e.target.value), 'Qty', orderDetailItem.ODID) }}
                />
            </td>
            <td>
                <Select className="input-sm input-width-160"
                    options={units}
                    onChange={(e) => { handleInputChange(e.value, 'UnitID', orderDetailItem.ODID) }}
                    value={unitSelectedValue}
                    placeholder="Select Unit"
                    components={{ Option: CustomOptionAgent }}

                ></Select>
            </td>
            <td>
                <input
                    type="text"
                    value={ProductName}
                    className="form-control input-sm "
                    disabled
                />
            </td>
            <td valign="middle">
                <input
                    type="checkbox"
                    onChange={(e) => { handleInputChange(e.target.checked ? 1 : 0, 'CntException', orderDetailItem.ODID) }}
                    className="form-check-input float-end"
                    checked={orderDetailItem.CntException}
                />
            </td>
            <td>
                <input
                    type="text"
                    value={orderDetailItem.Count}
                    onChange={(e) => { handleInputChange(e.target.value, 'Count', orderDetailItem.ODID) }}
                    onBlur={(e) => handleCountChange(orderDetailItem)}
                    className="form-control input-sm text-end input-width-110"
                />
            </td>
            <td valign="middle">
                <input
                    type="checkbox"
                    onChange={(e) => { handleInputChange(e.target.checked ? 1 : 0, 'BPException', orderDetailItem.ODID) }}
                    className="form-check-input float-end "
                    checked={orderDetailItem.BPException}
                />
            </td>
            <td>
                <div className="position-relative input-icon">
                    <input
                        type="text"
                        className="form-control input-sm text-end ps-4 input-width-110"
                        value={orderDetailItem.BuyPrice}
                        onChange={(e) => { handleInputChange(e.target.value, 'BuyPrice', orderDetailItem.ODID) }}
                        onBlur={() => handleBuyPriceChange(orderDetailItem)}
                    />
                    <span className="text-lite cps-10 fs-14">
                        $
                    </span>
                </div>
            </td>
        </tr>
    );
}

export const BuyPriceTableRow = React.memo(RowComponent);
